import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { EQUIPMENTS_VOLUME_CHART_ENDPOINT } from '../equipment-chart-endpoints';

export const EQUIPMENT_STATE_ALL_DONUT_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.EQUIPMENT_STATE_ALL_DONUT,
    chartType: ChartRendererType.PIE,
    endpoint: EQUIPMENTS_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }],
    groupBy: ChartQueryParam.STATE
};
